// extracted by mini-css-extract-plugin
module.exports = {"Palette":"Palette_Palette__3AJR8","selected":"Palette_selected__sBYNN","swatch":"Palette_swatch__FTL5X","add":"Palette_add__2PWke","random":"Palette_random__3jaxC"};